import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { fetchWonItemsCount } from './wonItemsCount.api';
import { FetchWonItemsCountResponse } from './wonItemsCount.type';
import { getAuthToken, getBidderId } from '../user';
import { getDeployment } from '../config';
import { shouldFetch } from './wonItemsCount.selectors';

export const loadWonItemsCount = createAsyncThunk<FetchWonItemsCountResponse>(
    'la/domain/wonItemsCount/loadWonItemsCount',
    async (input, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);

        const response = await fetchWonItemsCount({
            authToken,
            bidderId,
            deployment,
        });

        return {
            actionTime: Date.now(),
            payload: response.payload,
        };
    }
);

export const fetchWonItemsCountIfNeeded = createAsyncThunk<void, void>(
    'la/domain/wonItemsCount/fetchWonItemsCountIfNeeded',
    async (input, { dispatch, getState }) => {
        const state = getState();
        if (shouldFetch(state)) {
            await dispatch(loadWonItemsCount());
        }
    }
);
